import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { fetchCampaignPosts } from "./campaignPosts.actions";
import { initialState } from "./campaignPosts.initial-state";
import { Post } from "./campaignPosts.types";

const campaignPostsSlice = createSlice({
  name: "campaignPosts",
  initialState,
  reducers: {
    setCampaignPosts: (state, action: PayloadAction<Post[]>) => {
      state.data = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCampaignPosts.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCampaignPosts.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(fetchCampaignPosts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch posts";
      })
  },
});

export const { setCampaignPosts } = campaignPostsSlice.actions;
const campaignPostsReducer = campaignPostsSlice.reducer;
export default campaignPostsReducer;
